import { render } from "./Submit_Ticket.vue?vue&type=template&id=d4d928f4&scoped=true"
import script from "./Submit_Ticket.vue?vue&type=script&lang=js"
export * from "./Submit_Ticket.vue?vue&type=script&lang=js"

import "./Submit_Ticket.vue?vue&type=style&index=0&id=d4d928f4&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\Admin_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4d928f4"]])

export default __exports__